export const DATE_PICKER_STYLE = {
    minWidth: 130,
    maxWidth: 130,
    height: "40px",
    fontSize: "14px",
    borderRadius: "5px"
};

export const SYSTEM_DEFAULT_START_TIME = "09:00";
export const SYSTEM_DEFAULT_END_TIME = "18:00";

export const LONG_RANGE_HOURS = 24;
export const TWO_DAY_RANGE_HOURS = 48;